export const userComments = {
  testimonials: [
    {
      id: "sort-11",
      content: `We traveled to Yunnan in March 2025 as a couple and had an amazing experience thanks to Real Yunnan. From start to finish, everything was well-organized and thoughtful. Tom, who helped us plan the trip, was incredibly attentive and always responded to our emails promptly. His professionalism and care really stood out.
                We visited Kunming, Dali, and Lijiang, and each stop had its own charm.
                Overall, we are very grateful to Real Yunnan for making our trip so smooth and memorable.`,
      name: "James",
      country: "Australia",
      visitDate: "March 2025",
      itinerary: "14 Days Private Yunnan Tour",
      avatar: "/images/testimonials/guest11.jpg"
    },
    {
      id: "sort-12",
      content: `We had a wonderful family trip to Yunnan in Feb 2025, visiting Pu’er, Dali, Lijiang, and Kunming. Real Yunnan did a great job organizing everything. Tom was very responsive and helpful during the planning. One highlight was tea tasting in Jingmai Mountain—my husband especially loved it!
                Our guide in Dali, Judy, was fantastic and even prepared thoughtful gifts for us. Thank you, Real Yunnan, for an unforgettable journey. Highly recommended!`,
      name: "Vera",
      country: "Spain",
      visitDate: "Feb 2025",
      itinerary: "16 Days Private Yunnan Tea Tour",
      avatar: "/images/testimonials/guest12.jpg"
    },
    {
      id: "sort-13",
      content: `We chose Real Yunnan to plan our trip in Yunnan this April. 
                Tom have responded my email very fast and professional. He provided a few good suggestions. 
                Mr Yang is our driver in Dali and Lijiang, very kind and welcoming. 
                Thanks to my guide Jane as well, she is a very knowledgeable person makes our guided tour interesting. 
                We enjoyed our time in Yunnan and we are so grateful to Real Yunnan as a great tour operator. Highly recommend.`,
      name: "Gioia",
      country: "Italy",
      visitDate: "April 2025",
      itinerary: "22 days Yunnan Tour",
      avatar: "/images/testimonials/guest13.jpg"
    },
    {
      id: "sort-1",
      content: `We really appreciated the visit to the Tibetan family and we enjoyed our hotel in Shangri-La!! We have spent a really nice time in Yunnan, with really amazing guides in beautiful and heartbreaking places!!
                You are super efficient and super supportive!! I really appreciate your support and your professionalism.
                We love your country and we want to come back!!!
                Have. A good rest.`,
      name: "Monica",
      country: "Italy",
      visitDate: "December 2024",
      itinerary: "8 Days Classic Yunnan Tour",
      avatar: "/images/testimonials/guest1.jpg"
    },
    {
      id: "sort-2",
      content: `We had a very nice trip (on a private basis) organized by Real Yunnan. 
                Choices of destinations/small historic towns and points of interest (e.g. stone forest, rice paddy fields/terraces, mountains, rivers, etc.), hotels/guest houses and restaurants were perfect and met our expectations. 
                The guides we had were friendly and knowledgeable. We also had good drivers with clean comfortable cars. 
                We highly recommend this agency since we were very satisfied of the services provided and their responsiveness.`,
      name: "Rita",
      country: "USA",
      visitDate: "December 2024",
      itinerary: "15 Days Yunnan Private Tour",
      avatar: "/images/testimonials/guest8.jpg"
    },
    {
      id: "sort-3",
      content: `¡Ya estamos en casa sanos, salvos y muy felices! Muchas gracias por tus servicios y por la agradable invitación a cenar. 
                ¡Seguiremos en contacto para futuros viajes a China y Tíbet!
                ¡Nuestros mejores deseos!`,
      name: "Isabel",
      country: "Spain",
      visitDate: "May 2024",
      itinerary: "8 days classic Yunnan tour",
      avatar: "/images/testimonials/guest3.jpg"
    },
    {
      id: "sort-4",
      content: `Ciao! Siamo già tornati in Italia e lunedì riapriamo il nostro ristorante. 
                È stata una vacanza meravigliosa e ti ringraziamo moltissimo per l'organizzazione: tutto è stato perfetto! Spero di poterti mandare alcuni amici. 
                Se un giorno verrai a Firenze, chiamaci e saremo felici di farti da guida!
                Buon compleanno per il tuo lavoro!
                A presto!`,
      name: "Raymond and Maria",
      country: "Spain",
      visitDate: "May 2024",
      itinerary: "14 Days Yunnan Private Tour",
      avatar: "/images/testimonials/guest2.jpg"
    },
    {
      id: "sort-5",
      content: `I hope you and your family are good and have a wonderful new year.
                Please say hallo to our guides and drivers.
                We are drimming to come back China as soon as possibile.`,
      name: "Giorgio & Laura",
      country: "Italy",
      visitDate: "August 2024",
      itinerary: "8 Days Classic Yunnan Tour",
      avatar: "/images/testimonials/guest5.jpg"
    },
    {
      id: "sort-6",
      content: `Our guide Leo and our driver Mr Yang are very kind, professional and caring people. 
                Leo was our guide but also was taking care of us the whole time. Everything was very punctual and organized. 
                We could see more than in a usually trip thanks to Leo. 
                He knows very interesting facts and taking excellence photos.
                During driving from one destination to another we also had wonderful time with them. 
                We are super glad and miss Yunnan already.`,
      name: "Paul",
      country: "Germany",
      visitDate: "March 2025",
      itinerary: "14 Days Classic Yunnan Tour",
      avatar: "/images/testimonials/guest6.jpg"
    },
    {
      id: "sort-7",
      content: `Hello Lisa,
                everything was ok, I had good time. 
                The guide was very on time and helpful.
                Also my luggage was in my room at the hotel in Shangri-la. Good organization!
                Thank you very much for your help.
                Hope to go back to Yunnan one day!
                Thank you`,
      name: "Gianfranco",
      country: "Italy",
      visitDate: "April 2024",
      itinerary: "8 Days Classic Yunnan Tour",
      avatar: "/images/testimonials/guest4.jpg"
    }
  ]
};